export const phastosDesc = `Finalise tax returns by reviewing data readiness, understanding data insights, manage exceptions, apply adjustments, seek approvals and start filling.`;

export const excaliburDesc = "Get curated tax authority compliant xmls, csv, zip files for Tax Filing."

export const filingDesc = "Have a Tax Filing report ready? Click to get started with filing on government tax portal."

export const configurationDesc = `Click to view details of the configure obligations`;